<div class="cell">
  @if (!menuContent || menuContent && !menuContent.templateRef) {
    <div>
      <button type="button" class="btn btn-icon primary transparent" (click)="menuEl.toggle($event)"><i
      aria-hidden="true" class=" icon icon-dotes"></i>
      <span class="sr-only">Menu</span>
    </button>
    <p-menu appendTo="body" #menuEl [popup]="true" [model]="menu"></p-menu>
  </div>
}
@if (menuContent && menuContent.templateRef) {
  <div class="has-float">
    <button type="button" class="btn btn-icon primary transparent" (click)="popoverEl.toggle($event)"><i
    aria-hidden="true" class=" icon icon-dotes"></i>
    <span class="sr-only">Menu</span>
  </button>
  <app-popover #popoverEl [left]="left" [top]="top">
    <ng-container [ngTemplateOutlet]="menuContent.templateRef"></ng-container>
  </app-popover>
</div>
}
</div>